import { ENDPOINT } from '~/constants';

import { isAbortError, type KyRequestOptions } from '@vestigas/data';

import { vestigasAiApi } from '~/services/kyClient';

import { log } from '~/utils';

import {
  type FilteredModelsQueryParameters,
  type FilteredModelsResponse,
} from './types';
import { zodFilteredModelsQueryParametersSchema } from './validations';

/**
 * Fetches all AI models filtered by type from the API.
 * Cached on the server for 30 minutes with background refresh.
 * @param queryParameters - The query parameters to fetch the AI models.
 * @returns The filtered AI models.
 * @see https://ai.vestigas.com/redoc#operation/get_filtered_models_get_models_get
 */
export const fetchFilteredModels = async (
  queryParameters: FilteredModelsQueryParameters,
  options?: KyRequestOptions,
) => {
  try {
    const response = await vestigasAiApi
      .get(ENDPOINT.AI.GET_FILTERED_MODELS(), {
        searchParams: queryParameters,
        validate: {
          searchParams: zodFilteredModelsQueryParametersSchema,
        },
        ...options,
      })
      .json<FilteredModelsResponse>();

    return response;
  } catch (error) {
    if (isAbortError(error)) {
      return;
    }

    log.error({
      message: 'Error fetching filtered AI models',
      error,
    });

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
